import MainCarouselCard from './MainCarouselCard';
import Toast from '../Common/Toast';
import React, { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { useLottie } from 'lottie-react';
import lottieMain from '../../data/lottie_main.json';
import useApi from '../../hooks/useApi';
import { useSetRecoilState } from 'recoil';
import { loadingSpinnerState } from '../../recoil/loadingSpinner/loadingSpinnerAtom';
import { useNavigate } from 'react-router-dom';
const MainCarousel = ({ isLogin }) => {
  const [isToastShow, setIsToastShow] = useState(false);
  const [spotlightList, setSpotlightList] = useState(null);
  const setIsLoading = useSetRecoilState(loadingSpinnerState);

  const api = useApi();
  const navigate = useNavigate();

  const fetchSpotlightList = async () => {
    setIsLoading(true);
    try {
      const response = await api.get(`mubeat_live/product/spotlight`);
      const fetchData = response?.data?.products;
      setSpotlightList(fetchData);
    } catch (error) {
      if (error.code === 'ERR_NETWORK' || error.code === 'ERR_BAD_RESPONSE') {
        navigate('/error');
      } else {
        console.log(error);
      }
    } finally {
      setIsLoading(false);
    }
  };

  const lottieOptions = {
    animationData: lottieMain,
    loop: true,
    autoplay: true,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice', // object-fit: cover 와 비슷한 옵션
    },
  };

  const { View, setSpeed } = useLottie(lottieOptions);

  const pagination = {
    type: 'fraction',
    formatFractionCurrent: (number) => ('0' + number).slice(-2),
    formatFractionTotal: (number) => ('0' + number).slice(-2),
  };

  // const handleToast = () => {
  //   setIsToastShow(true);
  // };

  useEffect(() => {
    fetchSpotlightList();
  }, []);

  useEffect(() => {
    let timer;
    if (isToastShow) {
      timer = setTimeout(() => {
        setIsToastShow(false);
      }, 4000);
    }

    return () => clearTimeout(timer);
  }, [isToastShow]);

  // lottie speed 조정
  useEffect(() => {
    setSpeed(1.75);
  }, []);

  useEffect(() => {
    const swiperNextButton = document.querySelector('.swiper-button-next');
    const swiperPrevButton = document.querySelector('.swiper-button-prev');
    const swiperPagination = document.querySelector('.swiper-pagination');
    const wrapper = document.createElement('div');
    wrapper.classList.add('main-carousel-custom-navigation-wrapper');

    const layoutInner = document.createElement('div');
    layoutInner.classList.add('layout-inner');

    if (swiperNextButton && swiperPrevButton && swiperPagination) {
      wrapper.appendChild(swiperPrevButton);
      wrapper.appendChild(swiperPagination);
      wrapper.appendChild(swiperNextButton);

      layoutInner.appendChild(wrapper);
      document.querySelector('.main-carousel-card-wrapper .swiper').appendChild(layoutInner);
    }
  }, []);

  return (
    <>
      <div className={'main-carousel-card-all-wrapper'}>
        <figure className='main-carousel-bg-group'>
          <img
            fetchpriority='high'
            src='/images/bg_main_carousel.png'
            alt={''}
            className={'main-carousel-bg mb-hide'}
            decoding={'async'}
            width={'1920'}
            height={'650'}
          />
          <img
            fetchpriority='high'
            src='/images/bg_main_carousel_mb.png'
            alt={''}
            className={'main-carousel-bg mb-show'}
            decoding={'async'}
            width={'375'}
            height={'455'}
          />
          <div className={'main-carousel-lottie-bg'}>{View}</div>
        </figure>
        <div className={'main-carousel-card-wrapper'}>
          <Swiper
            pagination={pagination}
            modules={[Pagination, Navigation, Autoplay]}
            slidesPerView={1}
            navigation
            speed={800}
          >
            {spotlightList?.map((item) => (
              <SwiperSlide key={item.id}>
                {/*<MainCarouselCard item={item} onButtonClick={handleToast} />*/}
                <MainCarouselCard item={item} isLogin={isLogin} />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
      {isToastShow ? <Toast isShow={isToastShow} toastMsg={'URL이 복사되었습니다.'} /> : null}
    </>
  );
};

export default MainCarousel;
